/* Legeldle - zold "online" potty a Shopify Inbox chat gombjan.
   Az Inbox gombja (button.activator) a <shopify-chat> elem shadow DOM-jaban van,
   elso megnyitas utan pedig egy szinttel melyebben (<shopify-agent-runtime>).
   Minden olyan shadow rootba betesszuk a stilust, ahol a gomb megtalalhato.
   Nyitott chatnel (aria-expanded="true") a potty eltunik. */
(function () {
  if (window.__lgdChatDot) return;
  window.__lgdChatDot = true;

  var CSS =
    '.activator{position:relative;overflow:visible}' +
    '.activator::after{content:"";position:absolute;top:-3px;right:-3px;width:14px;height:14px;' +
    'border-radius:50%;background:#22c55e;border:2px solid #fff;box-sizing:border-box;' +
    'pointer-events:none;z-index:2;animation:lgdChatPulse 2s ease-out infinite}' +
    '.activator[aria-expanded="true"]::after{display:none}' +
    '@keyframes lgdChatPulse{0%{box-shadow:0 0 0 0 rgba(34,197,94,.75)}' +
    '70%{box-shadow:0 0 0 9px rgba(34,197,94,0)}100%{box-shadow:0 0 0 0 rgba(34,197,94,0)}}' +
    '@media (prefers-reduced-motion:reduce){.activator::after{animation:none}}';

  function addStyle(root) {
    if (!root.querySelector('.activator') || root.querySelector('#lgd-online-dot')) return;
    var s = document.createElement('style');
    s.id = 'lgd-online-dot';
    s.textContent = CSS;
    root.appendChild(s);
  }

  function inject() {
    var hosts = document.querySelectorAll('shopify-chat, inbox-online-store-chat');
    for (var i = 0; i < hosts.length; i++) {
      var root = hosts[i].shadowRoot;
      if (!root) continue;
      addStyle(root);
      // Egy szinttel melyebb shadow rootok (pl. shopify-agent-runtime)
      var inner = root.querySelectorAll('*');
      for (var j = 0; j < inner.length; j++) {
        if (inner[j].shadowRoot) addStyle(inner[j].shadowRoot);
      }
    }
  }

  // A chat kesobb toltodik be es ujraepiti magat: rendszeresen ellenorizzuk.
  inject();
  setInterval(inject, 1000);
})();
